import { appConfig } from "@/appConfig";
import { RouteRecordRawMeta } from "@/common/util/types";
import { RouteParamsRaw, useRoute, useRouter } from "vue-router";

export const useCurrentRoute = () => {
    const route = useRoute();
    return route as unknown as RouteRecordRawMeta & ReturnType<typeof useRoute>;
};

// 控制器
let routeing = false;

export const useNavigation = () => {
    const routeHandler = (handle: () => void) => {
        if (routeing) return;
        routeing = true;
        handle();
        setTimeout(() => {
            routeing = false;
        }, 500);
    };
    const router = useRouter();

    /**
     * 下一页
     * @param path 
     */
    const toNext = (path: string, query?: RouteParamsRaw, params?: RouteParamsRaw) => {
        routeHandler(() => {
            router.push({
                path,
                params: params || {},
                query: query || {},
            });
        });
    }
    
    /**
     * 重定向页
     * @param path 
     */
    const toReplace = (path: string, query?: RouteParamsRaw, params?: RouteParamsRaw) => {
        routeHandler(() => {
            router.replace({
                path,
                params: params || {},
                query: query || {},
            });
        });
    }
    
    /**
     * 上一页
     */
    const toBack = () => {
        routeHandler(() => {
            if (router.currentRoute.value.meta.isHomeRoute) {
                appConfig.sdk.backWeb();
                return;
            }
            router.back();
        });
    }
    
    return {
        toBack,
        toNext,
        toReplace,
    };
}